export const ADD_TEST_SUCCESS = 'ADD_TEST_SUCCESS';

export const INIT = 'INIT';

export const START_GAME_SUCCESS = 'START_GAME_SUCCESS';
export const END_GAME_SUCCESS = 'END_GAME_SUCCESS';

export const START_ROUND_SUCCESS = 'START_ROUND_SUCCESS';
export const END_ROUND_SUCCESS = 'END_ROUND_SUCCESS';
export const PAUSE_ROUND_SUCCESS = 'PAUSE_ROUND_SUCCESS';

export const NEXT_PHASE_SUCCESS = 'NEXT_PHASE_SUCCESS';
export const RESET_PHASE_SUCCESS = 'RESET_PHASE_SUCCESS';

export const ADD_BLUE_SUCCESS = 'ADD_BLUE_SUCCESS';
export const ADD_RED_SUCCESS = 'ADD_RED_SUCCESS';
export const SWITCH_TEAM_SUCCESS = 'SWITCH_TEAM_SUCCESS';

export const NEXT_CARD_SUCCESS = 'NEXT_CARD_SUCCESS';

export const TICK_SUCCESS = 'TICK_SUCCESS';
export const TIMER_RESET_SUCCESS = 'TIMER_RESET_SUCCESS';
export const TIMER_STOP_SUCCESS = 'TIMER_STOP_SUCCESS';
export const TIMER_START_SUCCESS = 'TIMER_START_SUCCESS';

export const RANDOM_DECK_SUCCESS = 'RANDOM_DECK_SUCCESS';

export const LOAD_CARDS_SUCCESS = 'LOAD_CARDS_SUCCESS';
export const LOAD_AND_SHUFFLE_CARDS_SUCCESS = 'LOAD_AND_SHUFFLE_CARDS_SUCCESS';
export const SHIFT_CARDS_SUCCESS = 'SHIFT_CARDS_SUCCESS';
export const SCORE_CARDS_SUCCESS = 'SCORE_CARDS_SUCCESS';

export const INSTRUCTIONS_DELIVERED_SUCCESS = 'INSTRUCTIONS_DELIVERED_SUCCESS';
export const INSTRUCTIONS_CLEARED_SUCCESS = 'INSTRUCTIONS_CLEARED_SUCCESS';

export const ADD_REDTEMPSCORE_SUCCESS = 'ADD_REDTEMPSCORE_SUCCESS';
export const ADD_REDCARD_SUCCESS = 'ADD_REDCARD_SUCCESS';
export const ADD_REDPASS_SUCCESS = 'ADD_REDPASS_SUCCESS';
export const ZERO_REDTEMPSCORE_SUCCESS = 'ZERO_REDTEMPSCORE_SUCCESS';
export const ZERO_REDCARD_SUCCESS = 'ZERO_REDCARD_SUCCESS';
export const ZERO_REDPASS_SUCCESS = 'ZERO_REDPASS_SUCCESS';

export const ADD_BLUETEMPSCORE_SUCCESS = 'ADD_BLUETEMPSCORE_SUCCESS';
export const ADD_BLUECARD_SUCCESS = 'ADD_BLUECARD_SUCCESS';
export const ADD_BLUEPASS_SUCCESS = 'ADD_BLUEPASS_SUCCESS';
export const ZERO_BLUETEMPSCORE_SUCCESS = 'ZERO_BLUETEMPSCORE_SUCCESS';
export const ZERO_BLUECARD_SUCCESS = 'ZERO_BLUECARD_SUCCESS';
export const ZERO_BLUEPASS_SUCCESS = 'ZERO_BLUEPASS_SUCCESS';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js